import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { PortalMerchantEditAddForm } from "./PortalMerchantEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { fetchSinglePortalMerchant, updatePortalMerchant, createPortalMerchant } from "../../../actions/merchants/merchants";

export function PortalMerchantEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();

  const { portalmerchantForEdit } = useSelector(
    (state) => ({
      portalmerchantForEdit: id ? state.merchants.portalmerchantForEdit?.docs : undefined,
    }),
    shallowEqual
  );

  var initMerchantsInfo = {
    firstname: '',
    lastname: '',
    username: '',
    email: '',
    password: '',
    rpassword: '',
    status: 'yes',
  }

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    await dispatch(fetchSinglePortalMerchant(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Portal Merchant";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Portal Merchant";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{ pathname: '/merchants', title: 'Merchant' }, { pathname: '', title: title }]);
    } else {
      suhbeader.setBreadcrumbs([{ pathname: '/merchants', title: 'Merchant' }, { pathname: '', title: title }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tabvalue = params.get('tab');

  const saveMerchantInfo = (values) => {
    setIsLoading(true);
    if (id) {
      dispatch(updatePortalMerchant(values, id)).then(async (data) => {
        if (data && data.payload) {
          await history.push(`/merchants?tab=${tabvalue}`);
          
          await enqueueSnackbar("Merchant updated successfully", {
            variant: "success",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else {
      dispatch(createPortalMerchant(values)).then(async (data) => {
        if (data && data.payload) {
          await history.push(`/merchants?tab=${tabvalue}`);
            
          await enqueueSnackbar("Merchant created successfully", {
            variant: "success",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveMerchantButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/merchants?tab=${tabvalue}`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <PortalMerchantEditAddForm
              merchants={portalmerchantForEdit || initMerchantsInfo}
              id={id}
              btnRef={btnRef}
              saveMerchantInfo={saveMerchantInfo}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveMerchantButtonClick}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
